import { useTranslation } from 'next-i18next';

import { Box, Flex, Text } from '@chakra-ui/react';

import { Alert } from '@nocowanie/common-ui';

import { UnavailabilityCTAProps } from './unavailability-cta.props';

export const UnavailabilityCTAItem = ({
    children,
    customErrorText,
    labelTranslationKey,
    roomLabelTranslationKey,
    textProps,
    hideLabels = false,
    isSingleApartment = false,
    labelsShort = false,
    ...props
}: UnavailabilityCTAProps & {
    labelTranslationKey: string;
    roomLabelTranslationKey: string;
}) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'pricing',
    });

    return (
        <Flex gap={'gutterWidth'} justifyContent={'space-between'} {...props}>
            {!hideLabels ? (
                isSingleApartment || labelsShort ? (
                    <Text color={'red.solid'} {...textProps}>
                        {t(isSingleApartment ? roomLabelTranslationKey : labelTranslationKey)}
                    </Text>
                ) : (
                    <Alert
                        status="error"
                        dangerouslySetInnerHTML={{
                            __html: customErrorText ?? t(labelTranslationKey),
                        }}
                    />
                )
            ) : null}
            <Box>{children}</Box>
        </Flex>
    );
};
